//https://dev.to/dmtrkovalenko/the-neatest-way-to-handle-alert-dialogs-in-react-1aoe

import React from 'react';
import { ConfirmationDialog } from '../components/ConfirmDialog';

export enum CONFIRM_TYPES {
  confirm,
  yesno,
  yesnocancel,
}
export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  type?: CONFIRM_TYPES;
  variant?: 'danger' | 'info';
  title: string;
  description: string;
}

// we will pass the opening dialog function directly to consumers
export const ConfirmationServiceContext = React.createContext<(options: ConfirmationOptions | string) => Promise<boolean | void>>(Promise.reject);

export const ConfirmationServiceProvider = ({ children, theme }) => {
  const [confirm, setConfirm] = React.useState<ConfirmationOptions | null>(null);

  const awaitingPromiseRef = React.useRef<{
    resolve: (a?: boolean) => void;
    reject: (a?: boolean) => void;
  }>();

  const openConfirmation = (options: ConfirmationOptions | string) => {
    if (typeof options === 'string') {
      setConfirm({ title: 'Confirm', description: options });
    } else {
      setConfirm(options);
    }
    return new Promise<boolean | void>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (confirm?.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }

    setConfirm(null);
  };

  const handleSubmit = (response) => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve(response);
    }

    setConfirm(null);
  };

  return (
    <>
      <ConfirmationServiceContext.Provider value={openConfirmation} children={children} />
      <ConfirmationDialog theme={theme} open={Boolean(confirm)} onSubmit={handleSubmit} onClose={handleClose} {...confirm} />
    </>
  );
};
